/**
 * Formats raw provider slugs or names (e.g. "donut-gaming", "axisframe_gaming", "1x2")
 * into clean, branded display names.
 */
export const formatProviderName = (rawName?: string | null): string => {
  if (!rawName) return '';

  const customMap: Record<string, string> = {
    ai: 'AI',
    '1x2': '1X2',
    bg: 'BG',
    cg: 'CG',
    bf: 'BF',
  };

  const clean = rawName.trim().toLowerCase();
  if (customMap[clean]) return customMap[clean];

  return clean
    .replace(/[-_]+/g, ' ')
    .split(' ')
    .filter(Boolean)
    .map((word) => customMap[word] || (word.charAt(0).toUpperCase() + word.slice(1)))
    .join(' ')
    .trim();
};
